import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Notification from "@components/notification";
import Loader from "@components/loader";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import React from "react";
import { Documents, Container } from "@components_v2/layout/layout.styled";

const LayoutForOnlyComponent = ({ children }) => {
    const globalLoading = useSelector((state) => state.global.loading);

    return (
        <DndProvider backend={HTML5Backend}>
            <Documents>
                <Container>{children}</Container>
                {globalLoading && <Loader />}
                <Notification />
            </Documents>
        </DndProvider>
    );
};

LayoutForOnlyComponent.propTypes = {
    children: PropTypes.element,
};

export default LayoutForOnlyComponent;
